export default __webpack_public_path__ + "static/media/unavailableBG.0a8a8dfe.svg";